import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// LiveKit's component styles first, then ours — theme.css only overrides the
// --lk-* custom properties, so it has to be able to win.
import '@livekit/components-styles';
import './theme.css';

import { App } from './App';
import { loadBrand } from './brand';

const root = document.getElementById('root');
if (!root) throw new Error('#root missing from index.html');

// Brand FIRST, then render — never render-then-correct. The alternative shows the
// default name for a beat and swaps it for the operator's, which on the sign-in
// card is the one screen where briefly looking like a different product matters.
// loadBrand never rejects, so this always reaches render.
void loadBrand().then(() => {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
